import { render } from "./CriticalErrorOverlay.vue?vue&type=template&id=41cb50df&scoped=true"
import script from "./CriticalErrorOverlay.vue?vue&type=script&lang=js"
export * from "./CriticalErrorOverlay.vue?vue&type=script&lang=js"

import "./CriticalErrorOverlay.vue?vue&type=style&index=0&id=41cb50df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41cb50df"]])

export default __exports__